import React from "react";
import { Modal, Button, Alert } from "antd";
import { SendOutlined } from "@ant-design/icons";

interface SendTenderReviewModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  title?: string;
  message?: string;
  confirmButtonText?: string;
  warningMessage?: string;
}

const SendTenderReviewModal: React.FC<SendTenderReviewModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  loading = false,
  title = "Send Tender for Review",
  message = "Do you want to send this tender for review?",
  confirmButtonText = "Confirm & Send",
  warningMessage,
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      footer={
        <div className="flex justify-end gap-2" style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px', marginLeft: '-24px', marginRight: '-24px', paddingLeft: '24px', paddingRight: '24px', marginBottom: '-20px', paddingBottom: '20px' }}>
          <Button onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="primary"
            icon={<SendOutlined />}
            onClick={onConfirm}
            loading={loading}
            style={{
              backgroundColor: '#1890ff',
              borderColor: '#1890ff'
            }}
          >
            {confirmButtonText}
          </Button>
        </div>
      }
      width={500}
      closable={!loading}
      maskClosable={!loading}
      centered
      styles={{
        header: {
          backgroundColor: '#f5f5f5',
          marginLeft: '-24px',
          marginRight: '-24px',
          marginTop: '-20px',
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingTop: '16px',
          paddingBottom: '16px'
        }
      }}
    >
      <div className="py-2">
        {warningMessage && (
          <Alert
            message={warningMessage}
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        <p className="text-base mb-3">
          {message}
        </p>
      </div>
    </Modal>
  );
};

export default SendTenderReviewModal;
